export default "__VITE_ASSET__e642c5d2__"